import { Controller } from "@hotwired/stimulus"
import TurndownService from "turndown"

export default class extends Controller {
  static targets = ["textarea", "preview", "writeTab", "previewTab"]

  connect() {
    this.turndown = new TurndownService({
      headingStyle: "atx",
      codeBlockStyle: "fenced"
    })

    this.boundHandlePaste = this.handlePaste.bind(this)
    this.textareaTarget.addEventListener("paste", this.boundHandlePaste)
  }

  disconnect() {
    this.textareaTarget.removeEventListener("paste", this.boundHandlePaste)
  }

  handlePaste(event) {
    const clipboardData = event.clipboardData
    if (!clipboardData) return

    // Skip turndown if pasting an image — let image_upload_controller handle it
    if (this.hasImageInClipboard(clipboardData)) return

    const html = clipboardData.getData("text/html")
    if (!html) return

    event.preventDefault()

    const markdown = this.turndown.turndown(html)
    const textarea = this.textareaTarget
    const start = textarea.selectionStart
    const end = textarea.selectionEnd
    const text = textarea.value

    textarea.value = text.substring(0, start) + markdown + text.substring(end)
    textarea.selectionStart = textarea.selectionEnd = start + markdown.length
    textarea.dispatchEvent(new Event("input", { bubbles: true }))
  }

  hasImageInClipboard(clipboardData) {
    if (!clipboardData.items) return false
    for (const item of clipboardData.items) {
      if (item.type.startsWith("image/")) return true
    }
    return false
  }

  showWrite() {
    if (!this.hasPreviewTarget) return

    this.textareaTarget.classList.remove("hidden")
    this.previewTarget.classList.add("hidden")
    this.writeTabTarget.classList.add("tab-active")
    this.writeTabTarget.classList.remove("tab-inactive")
    this.previewTabTarget.classList.add("tab-inactive")
    this.previewTabTarget.classList.remove("tab-active")
  }

  async showPreview() {
    if (!this.hasPreviewTarget) return

    const body = this.textareaTarget.value
    if (!body.trim()) {
      this.previewTarget.innerHTML = '<p class="text-gray-400">내용을 입력하세요.</p>'
    } else {
      try {
        const response = await fetch("/markdown/preview", {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
          },
          body: `body=${encodeURIComponent(body)}`
        })
        this.previewTarget.innerHTML = await response.text()
      } catch {
        this.previewTarget.innerHTML = '<p class="text-red-500">미리보기를 불러올 수 없습니다.</p>'
      }
    }

    this.textareaTarget.classList.add("hidden")
    this.previewTarget.classList.remove("hidden")
    this.previewTabTarget.classList.add("tab-active")
    this.previewTabTarget.classList.remove("tab-inactive")
    this.writeTabTarget.classList.add("tab-inactive")
    this.writeTabTarget.classList.remove("tab-active")
  }
}
